/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

/*
 * IMPORTS
 */

import $ from 'jquery';
import * as vars from '../../globals/variables';
import {params} from './params/params';
import flatpickr from 'flatpickr';

/*
 * YOUR CODE
 */

// Bei globalDynForms nur den Dynfromcode des Wrappers verwenden
let globalDynForms = {
    'std_request_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if (container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }
            setTimeout(function(){
                console.log(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'));
                if(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'))
                    document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)').innerHTML = window.BN.lang.constants.text.rooms;
            }, 200);
        }
    },
    'std_request_2017_phone': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if (container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }
            setTimeout(function(){
                console.log(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'));
                if(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'))
                    document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)').innerHTML = window.BN.lang.constants.text.rooms;
            }, 200);
        }
    },
    'std_request_2017_seminar_phone': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if (container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }
            setTimeout(function(){
                console.log(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'));
                if(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'))
                    document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)').innerHTML = window.BN.lang.constants.text.rooms;
            }, 200);
        }
    },
    'std_request_2017_event_phone': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if (container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }
            setTimeout(function(){
                console.log(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'));
                if(document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)'))
                    document.querySelector('.bn-form__block--rooms .bn-form__column--teaser > :nth-child(1)').innerHTML = window.BN.lang.constants.text.rooms;
            }, 200);
        }
    },
    'std_eventrequest_phone_2020': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorTEXT, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorPRIMARY, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if (container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }

            let keys = ["Verpflegung", "Bestuhlung", "Kaffeepause", "Fahrzeug mieten", "E-Bike mieten"];
            let labels = ["Accommodation", "Seating", "Coffee break", "Vehicle rental", "E-bike rental"];
            if (document.body.getAttribute('data-lang') === "de")
                labels =  ["Verpflegung", "Bestuhlung", "Kaffeepause", "Fahrzeug mieten", "E-Bike mieten"];

            let optionalsContainer = document.querySelector('.bn-optionals-list');

            let eventListener = function () {
                let destination = document.querySelector('.bn-form__column--reservation_optionals input');
                destination.value = "";
                document.querySelectorAll('div.bn-form__column--optional input:checked').forEach(function (item) {
                    destination.value +=  item.getAttribute('data-key') + ", ";
                });
                destination.value = destination.value.substring(0, destination.value.length - 2);
            };

            for(let i = 0; i < keys.length; i++){
                var temp = optionalsContainer.getElementsByTagName("template")[0];
                var clon = temp.content.cloneNode(true);

                var groupElement = document.createElement("div");
                groupElement.appendChild(clon);
                groupElement.classList.add('bn-form__column');
                groupElement.classList.add('bn-form__column--optional');
                groupElement.classList.add('bn-col_4');

                groupElement.querySelector('label').children[2].innerHTML = labels[i];
                groupElement.querySelector('input').setAttribute('data-key', keys[i]);

                optionalsContainer.appendChild(groupElement);

                groupElement.querySelector('input').addEventListener('input', eventListener);
            }
        }
    },
    'std_quickrequest_2017_seaside': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_quick_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color2': vars.dynformsColors.colorTEXT, // Farbe Input Labels & Inputs
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {
            document.querySelector('#bn-quick-request--v1 .bn-form__button-container button span').innerHTML = BN.lang.constants.text.quick_request_addition_3;

            if (!$('body').hasClass('seminar-page')) {
                let bookButton = document.createElement("DIV");
                bookButton.classList.add('bn-form__column');
                bookButton.classList.add('bn-form__column--submit');
                bookButton.innerHTML = '<div class="bn-form__group"><div class="bn-form__button-container"><a target="_blank" href="' + BN.lang.constants.text.booklink + '" class="bn-form__button bn-form__button--v1"><span>' + BN.lang.constants.text.book + '</span></button></div></div>';
                document.getElementById('bn-quick-request--v1').querySelector('.bn-form__row').appendChild(bookButton);
            }

            if ($('body').hasClass('seminar-page')) {
                $('#bn-quick-request--v1 .bn-form__groupIcon').addClass('bn-form__hidden');
                $('#bn-quick-request--v1 .bn-form__column--nameprefix').addClass('bn-form__hidden');
                $('#bn-quick-request--v1 .bn-form__column--children').addClass('bn-form__hidden');
                $('#bn-quick-request--v1 .bn-form__column--phone').removeClass('bn-form__hidden');
                $('#bn-quick-request--v1 .bn-form__column--company').removeClass('bn-form__hidden');

                $('#bn-quick-request--v1 .bn-form__column--guests .bn-form__label').html(BN.lang.constants.text.person_count);

                $('#bn-quick-request--v1 .bn-form__column--occasion_type').removeClass('bn-form__hidden');
                $('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__label').html($('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__label').html() + '*');
                $('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__input').attr('required', 'required');
            }
        },
        onBeforeSubmit: function () {
            if ($('body').hasClass('seminar-page')) {
                console.log($('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__input').val())
                if ($('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__input').val() == '') {
                    $('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__label')
                        .each(function() {
                            this.style.setProperty('color', 'red', 'important');
                        });
                    return false;
                } else {
                    $('#bn-quick-request--v1 .bn-form__column--occasion_type .bn-form__label')
                        .each(function() {
                            this.style.setProperty('color', '#fff', 'important');
                        });
                    return true;
                }
            } else {
                return true;
            }
        }
    },
    'std_newsletter_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_newsletter + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': '#80ff80', // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    },
    'std_request_2017_seminar': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_meeting_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {

            let flatPickerConfig = {
                dateFormat: "d.m.Y",
                minDate: "today",
                showMonths:  2,
            };

            let ChairFields = [
                ["Seminar", "Seminar"],
                ["Konzert", "Konzert"],
                ["U-Form", "U-Form"],
                ["Stuhlkreis", "Stuhlkreis"],
                ["Block", "Block"]
            ];

            let SupplyFields = [
                ["Begrüssungskaffee", "Begrüssungskaffee"],
                ["Mittagessen", "Mittagessen"],
                ["Aperitif", "Aperitif"],
                ["Vormittagspause", "Vormittagspause"],
                ["Nachmittagspause", "Nachmittagspause"],
                ["Abendessen", "Abendessen"],
                ["Kulinarisches Event", "Kulinarisches Event"],
                ["Mineralwasser (im Seminarraum)", "Mineralwasser"],
                ["Kaffeemaschine (im Seminarraum)", "Kaffeemaschine"]
            ];

            let TechFields = [
                ["Beamer (im Medienwagen inbegriffen),", "Beamer"],
                ["Moderationskoffer", "Moderationskoffer"],
                ["2x Flipcharts", "Flipcharts", 1],
                ["2x Pinnwand", "Pinnwand", 1],
            ];
            let SocialFields = [
                ["Social Event", "Social Event"]
            ];
            let PayFields = [
                ["Presenter", "Presenter"],
                ["Mikrophon", "Mikrophon"],
                ["Headset", "Headset"],
                ["Visualizer", "Visualizer"],
                ["Flipcharts (ab dem 3. Flipchart)", "Flipcharts", 1],
                ["Pinnwand (ab der 3. Pinnwand)", "Pinnwand", 1],
            ];

            // Translate

            //French
            if(document.body.getAttribute('data-lang') === "fr") {
                ChairFields = [
                    ["Séminaire", "Seminar"],
                    ["Concert", "Konzert"],
                    ["Forme de U", "U-Form"],
                    ["Cercle de chaises", "Stuhlkreis"],
                    ["Bloc", "Block"]
                ];
                SupplyFields = [
                    ["Café de bienvenue", "Begrüssungskaffee"],
                    ["Déjeuner", "Mittagessen"],
                    ["Apéritif", "Aperitif"],
                    ["Pause du matin", "Vormittagspause"],
                    ["Pause de l’après-midi", "Nachmittagspause"],
                    ["Dîner", "Abendessen"],
                    ["Evénement culinaire", "Kulinarisches Event"],
                    ["Eau minérale (est à votre disposition) dans la salle de conférence", "Mineralwasser"],
                    ["Machine à café (est à votre disposition) dans la salle de conférence", "Kaffeemaschine"]
                ];
                TechFields = [
                    ["Projecteur", "Beamer"],
                    ["Coffret de modération", "Moderationskoffer"],
                    ["2x Tableau à feuilles ", "Flipcharts", 1],
                    ["2x Tableau d’affichage ", "Pinnwand", 1],
                ];
                SocialFields = [
                    ["Evénement social", "Social Event"]
                ];
                PayFields = [
                    ["Télécommande pour présentation", "Presenter"],
                    ["Microphone", "Mikrophon"],
                    ["Casque", "Headset"],
                    ["Visualiseur", "Visualizer"],
                    ["Tableau à feuilles (à partir du 3ème)", "Flipcharts", 1],
                    ["Tableau d’affichage (à partir du 3ème)", "Pinnwand", 1],
                ];
            }

            //English
            if(document.body.getAttribute('data-lang') === "en") {
                ChairFields = [
                    ["Seminar", "Seminar"],
                    ["Concert", "Konzert"],
                    ["U-shape", "U-Form"],
                    ["Circle of chairs", "Stuhlkreis"],
                    ["Block", "Block"]
                ];
                SupplyFields = [
                    ["Welcome coffee ", "Begrüssungskaffee"],
                    ["Lunch", "Mittagessen"],
                    ["Aperitif", "Aperitif"],
                    ["Morning break", "Vormittagspause"],
                    ["Afternooon break", "Nachmittagspause"],
                    ["Dinner", "Abendessen"],
                    ["Culinary event ", "Kulinarisches Event"],
                    ["Mineral water (is at your disposal) in the conference room", "Mineralwasser"],
                    ["Coffee machine (is at your disposal) in the conference room", "Kaffeemaschine"]
                ];
                TechFields = [
                    ["Projector", "Beamer"],
                    ["Presentation case", "Moderationskoffer"],
                    ["2x Flipchart  ", "Flipcharts", 1],
                    ["2x Pinboard  ", "Pinnwand", 1],
                ];
                SocialFields = [
                    ["Social event", "Social Event"]
                ];
                PayFields = [
                    ["Presenter", "Presenter"],
                    ["Microphone", "Mikrophon"],
                    ["Headset", "Headset"],
                    ["Visualiser", "Visualizer"],
                    ["Flipcharts (from the 3rd)", "Flipcharts", 1],
                    ["Pinboard (from the 3rd)", "Pinnwand", 1],
                ];
            }

            let optionalsList = [
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_seminar"] .bn-container--checkboxes_chairs'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_seminar"] #bn_request_checkboxes_chairs'),
                    items: ChairFields
                },
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_seminar"] .bn-container--checkboxes_board'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_seminar"] #bn_request_checkboxes_board'),
                    items: SupplyFields
                },
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_seminar"] .bn-container--checkboxes_tech'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_seminar"] #bn_request_checkboxes_tech'),
                    items: TechFields
                },
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_seminar"] .bn-container--checkboxes_pay'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_seminar"] #bn_request_checkboxes_pay'),
                    items: PayFields
                },
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_seminar"] .bn-container--checkboxes_social'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_seminar"] #bn_request_checkboxes_social'),
                    items: SocialFields
                }
            ];

            $('#bn_request[data-dynform_code="std_request_2017_seminar"]').find('.bn-form__block.bn-form__block--pay').removeClass('hidden');

            optionalsList.forEach(function (listItem) {
                listItem.items.forEach(function (item) {

                    let temp = listItem.container.getElementsByTagName("template")[0];
                    let clon = temp.content.cloneNode(true);
                    let container = listItem.container;
                    let destInput = listItem.destInput;

                    let groupElement = document.createElement("div");
                    groupElement.appendChild(clon);
                    groupElement.classList.add('bn-form__column');
                    groupElement.classList.add('bn-form__column--optional');
                    groupElement.classList.add('bn-col_4');

                    groupElement.querySelector('label').children[2].innerHTML = item[0];
                    groupElement.querySelector('input').setAttribute('data-key', item[1]);

                    container.appendChild(groupElement);

                    groupElement.querySelector('input').addEventListener('input', function () {
                        destInput.value = "";
                        container.querySelectorAll('input:checked').forEach(function (item) {
                            destInput.value +=  item.getAttribute('data-key') + ", ";
                        });
                        destInput.value = destInput.value.substring(0, destInput.value.length - 2);
                    });

                });
            });

            let optionalsContainer = document.querySelector('.bn-optionals-list');

            let eventListener = function () {
                let destination = document.querySelector('.bn-form__column--reservation_optionals input');
                destination.value = "";
                document.querySelectorAll('div.bn-form__column--optional input:checked').forEach(function (item) {
                    destination.value +=  item.getAttribute('data-key') + ", ";
                });
                destination.value = destination.value.substring(0, destination.value.length - 2);
            };
            document.querySelectorAll('.bn-form__times input').forEach(function (item) {
                item.type = "time";
            });
        }
    },
    'std_request_2017_event': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {
            let SupplyFields = [
                ["Frühstück", "Frühstück"],
                ["Mittagessen", "Mittagessen"],
                ["Aperitif", "Aperitif"],
                ["Kulinarisches Event", "Kulinarisches Event"],
                ["Empfang", "Empfang"],
                ["Snack", "Snack"],
                ["Abendessen", "Abendessen"]
            ];

            let TechFields = [
                ["Beamer", "Beamer"],
                ["Mikrophon", "Mikrophon"],
            ];

            // Translate

            //French
            if(document.body.getAttribute('data-lang') === "fr") {
                SupplyFields = [
                    ["Petit-déjeuner", "Frühstück"],
                    ["Déjeuner", "Mittagessen"],
                    ["Apéritif", "Aperitif"],
                    ["Evénement culinaire", "Kulinarisches Event"],
                    ["Accueil", "Empfang"],
                    ["En-cas", "Snack"],
                    ["Dîner", "Abendessen"]
                ];
                TechFields = [
                    ["Projecteur", "Beamer"],
                    ["Microphone", "Mikrophon"],
                ];
            }

            //English
            if(document.body.getAttribute('data-lang') === "en") {
                SupplyFields = [
                    ["Breakfast ", "Frühstück"],
                    ["Lunch", "Mittagessen"],
                    ["Aperitif", "Aperitif"],
                    ["Culinary event ", "Kulinarisches Event"],
                    ["Reception", "Empfang"],
                    ["Snack", "Snack"],
                    ["Dinner", "Abendessen"]
                ];
                TechFields = [
                    ["Projector", "Beamer"],
                    ["Microphone", "Mikrophon"],
                ];
            }

            let optionalsList = [
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_event"] .bn-container--checkboxes_board'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_event"] #bn_request_checkboxes_board'),
                    items: SupplyFields
                },
                {
                    container: document.querySelector('[data-dynform_code="std_request_2017_event"] .bn-container--checkboxes_tech'),
                    destInput: document.querySelector('[data-dynform_code="std_request_2017_event"] #bn_request_checkboxes_tech'),
                    items: TechFields
                },
            ];

            optionalsList.forEach(function (listItem) {
                listItem.items.forEach(function (item) {
                    console.log(listItem.container);
                    let temp = listItem.container.getElementsByTagName("template")[0];
                    let clon = temp.content.cloneNode(true);
                    let container = listItem.container;
                    let destInput = listItem.destInput;

                    let groupElement = document.createElement("div");
                    groupElement.appendChild(clon);
                    groupElement.classList.add('bn-form__column');
                    groupElement.classList.add('bn-form__column--optional');
                    groupElement.classList.add('bn-col_4');

                    groupElement.querySelector('label').children[2].innerHTML = item[0];
                    groupElement.querySelector('input').setAttribute('data-key', item[1]);

                    container.appendChild(groupElement);

                    groupElement.querySelector('input').addEventListener('input', function () {
                        destInput.value = "";
                        container.querySelectorAll('input:checked').forEach(function (item) {
                            destInput.value +=  item.getAttribute('data-key') + ", ";
                        });
                        destInput.value = destInput.value.substring(0, destInput.value.length - 2);
                    });

                });
            });

            let optionalsContainer = document.querySelector('.bn-optionals-list');

            let eventListener = function () {
                let destination = document.querySelector('.bn-form__column--reservation_optionals input');
                destination.value = "";
                document.querySelectorAll('div.bn-form__column--optional input:checked').forEach(function (item) {
                    destination.value +=  item.getAttribute('data-key') + ", ";
                });
                destination.value = destination.value.substring(0, destination.value.length - 2);
            };
            document.querySelectorAll('.bn-form__times input').forEach(function (item) {
                item.type = "time";
            });
        }
    }
};

//Bei specialDynforms nur die IDs des Wrappers verwenden
let specificDynforms = {
    'bn_quickrequest_vertical': {
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color2': vars.dynformsColors.colorSECONDARY, // Farbe Input Labels & Inputs
            'color3': vars.dynformsColors.colorSECONDARY, // Hintergrundfarbe Absenden Button
            'color4': vars.dynformsColors.colorPRIMARY, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    },
    'bn_newsletter_v3': {
        colors: {
            'color1': vars.dynformsColors.colorTEXT, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': '#eff5f6', // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    }
};

export {
    globalDynForms,
    specificDynforms
};


// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/config.js